import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { Form, Formik } from "formik";
import performRequest from "../api/request";
import { Toast } from "../CustomComponent/toast";
import { CustomErrorResponse } from "../CustomComponent/custom_error_response";
import { FcViewDetails } from "react-icons/fc";
import CustomInput from "../CustomComponent/custom_input";
import CustomSelect from "../CustomComponent/custom_select";
import FormSubmitButton from "../Components/layouts/formSubmitButton";
import SimpleButton from "../Components/layouts/simple_button";
import Footer from "../Components/Footer/footer";
import { ReqRefundInfo } from "../SchemaInfo/info";
import { ReqRefundSchema } from "../Schemas/Refund/req_refund_schema";
import CustomTextArea from "../CustomComponent/custom_textarea";
import FooterwithoutLogin from "./controllEnvironmentPolyhouse/footerwithoutLogin";

function ReqRefund() {
  const navigate = useNavigate();
  const [webinarData, setWebinarData] = useState([]);
  const handelSubmit = (values) => {
    if (
      values.contactNumber === "0000000000" ||
      values.contactNumber === "1111111111" ||
      values.contactNumber === "2222222222" ||
      values.contactNumber === "3333333333" ||
      values.contactNumber === "4444444444" ||
      values.contactNumber === "5555555555" ||
      values.contactNumber === "6666666666" ||
      values.contactNumber === "7777777777" ||
      values.contactNumber === "8888888888" ||
      values.contactNumber === "9999999999" ||
      values.contactNumber === "1234567890" ||
      values.contactNumber === "9876543210" ||
      values.contactNumber === "0987654321"
    ) {
      Toast("error", "Invalid phone number");
    } else {
      const formData = new FormData();
      for (let key in values) {
        formData.append(key, values[key]);
      }
      const headers = { "content-type": "multipart/form-data" };
      performRequest("POST", "/request/req-refund/", formData, headers)
        .then((res) => {
          if (res.status === 201) {
            Toast("success", "Request added successfully!");
            navigate(`/`);
          } else {
            Toast("error", "Error while creating request");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }
  };

  useEffect(() => {
    performRequest("GET", "/webinar/checkWebinarRefundTime").then((res) => {
      if (res.status === 200) {
        setWebinarData(res?.data?.webinar);
      } else {
        CustomErrorResponse(res);
      }
    });
  }, []);

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header d-print-none">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title mb-1">
                    <FcViewDetails className="fs-2 me-1" />
                    Request Refund
                  </h2>
                  <h4 className="text-muted">Add your refund request here.</h4>
                </div>
              </div>
            </div>

            <div className="row my-4">
              {/* Left Side Guidelines */}
              <div className="col-lg-4 col-md-12 mb-lg-0 mb-md-4">
                <div className="card shadow-sm border-0 h-100">
                  <div className="card-header bg-light">
                    <h3 className="card-title m-0">
                      Refund Request Guidelines
                    </h3>
                  </div>

                  <div className="card-body">
                    <div className="alert alert-info">
                      <ul className="ps-3 mb-0">
                        <li className="mb-2">
                          Please use the same email address and mobile number
                          that were used during registration or payment.
                        </li>

                        <li className="mb-2">
                          Upload a valid payment receipt or transaction
                          screenshot for faster verification.
                        </li>

                        <li className="mb-2">
                          Refund verification may take 3–7 working days
                          depending on the payment method.
                        </li>

                        <li className="mb-2">
                          Ensure that your bank account details are correct to
                          avoid refund delays.
                        </li>

                        <li className="mb-2">
                          Incomplete or incorrect information may result in
                          rejection of the refund request.
                        </li>
                      </ul>
                    </div>

                    <div className="alert alert-warning mb-0">
                      <strong>Note:</strong> Refunds will only be processed
                      after successful verification of payment details from our
                      database.
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side Form */}
              <div className="col-lg-8 col-md-12">
                <div className="card shadow-sm border-0">
                  <div className="card-header">
                    <h2 className="page-title m-0">New Refund Request</h2>
                  </div>

                  <Formik
                    initialValues={ReqRefundInfo}
                    validationSchema={ReqRefundSchema}
                    onSubmit={handelSubmit}
                  >
                    {(props) => (
                      <Form>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-12">
                              {/* Request For */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Request for
                                </label>

                                <div className="w-100 col">
                                  <CustomSelect
                                    name="reqFor"
                                    type="text"
                                    onChange={(e) => {
                                      props.setFieldValue(
                                        "reqFor",
                                        e.target.value
                                      );

                                      if (e.target.value !== "Webinar") {
                                        props.setFieldValue("webinarId", "");
                                      }
                                    }}
                                  >
                                    <option value="">select</option>

                                    <option value="Hydroponic Masterclass">
                                      Hydroponic Masterclass
                                    </option>

                                    <option value="Offline Training">
                                      Offline Training
                                    </option>

                                    <option value="Site Inspection">
                                      Site Inspection
                                    </option>

                                    <option value="Webinar">Webinar</option>
                                  </CustomSelect>

                                  {props.touched.reqFor &&
                                    props.errors.reqFor && (
                                      <p className="text-danger">
                                        {props.errors.reqFor}
                                      </p>
                                    )}
                                </div>
                              </div>

                              {/* Webinar Select */}
                              {props.values.reqFor === "Webinar" && (
                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Select Webinar
                                  </label>

                                  <div className="w-100 col">
                                    <CustomSelect name="webinarId" type="text">
                                      <option value="">select</option>

                                      {webinarData.map((item) => (
                                        <option key={item?.id} value={item?.id}>
                                          {item?.webinarName}
                                        </option>
                                      ))}
                                    </CustomSelect>

                                    {props.touched.webinarId &&
                                      props.errors.webinarId && (
                                        <p className="text-danger">
                                          {props.errors.webinarId}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              )}

                              {/* Name */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Name
                                </label>

                                <div className="w-100 col">
                                  <CustomInput name="name" type="text" />

                                  {props.touched.name && props.errors.name && (
                                    <p className="text-danger">
                                      {props.errors.name}
                                    </p>
                                  )}
                                </div>
                              </div>

                              {/* Email */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Email address
                                </label>

                                <div className="w-100 col">
                                  <CustomInput name="email" type="email" />

                                  <p className="text-info mt-1 mb-0">
                                    Please use the same email address used
                                    during registration or payment.
                                  </p>

                                  {props.touched.email &&
                                    props.errors.email && (
                                      <p className="text-danger">
                                        {props.errors.email}
                                      </p>
                                    )}
                                </div>
                              </div>

                              {/* Contact Number */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Contact number
                                </label>

                                <div className="w-100 col">
                                  <CustomInput
                                    type="text"
                                    name="contactNumber"
                                  />

                                  <p className="text-info mt-1 mb-0">
                                    Please use the same mobile number used while
                                    making the payment.
                                  </p>

                                  {props.touched.contactNumber &&
                                    props.errors.contactNumber && (
                                      <p className="text-danger">
                                        {props.errors.contactNumber}
                                      </p>
                                    )}
                                </div>
                              </div>

                              {/* Payment Receipt */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3 required">
                                  Payment receipt
                                </label>

                                <div className="w-100 col">
                                  <CustomInput
                                    type="file"
                                    name="paymentReceipt"
                                    onChange={(e) =>
                                      props.setFieldValue(
                                        "paymentReceipt",
                                        e.target.files[0]
                                      )
                                    }
                                  />

                                  {props.touched.paymentReceipt &&
                                    props.errors.paymentReceipt && (
                                      <p className="text-danger">
                                        {props.errors.paymentReceipt}
                                      </p>
                                    )}
                                </div>
                              </div>

                              {/* Message */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3 required">
                                  Message
                                </label>

                                <div className="w-100 col">
                                  <CustomTextArea
                                    rows={5}
                                    type="text"
                                    name="message"
                                  />

                                  {props.touched.message &&
                                    props.errors.message && (
                                      <p className="text-danger">
                                        {props.errors.message}
                                      </p>
                                    )}
                                </div>
                              </div>

                              {/* Bank Details */}
                              <hr className="m-2" />
                              <h2 className="m-0 p-2">Bank Details</h2>
                              <hr className="m-1" />

                              {/* Account Holder */}
                              <div className="mb-3 row mt-3">
                                <label className="w-25 form-label col-3 required">
                                  Account Holder Name
                                </label>

                                <div className="w-100 col">
                                  <CustomInput
                                    type="text"
                                    name="accountholderName"
                                  />

                                  {props.touched.accountholderName &&
                                    props.errors.accountholderName && (
                                      <p className="text-danger">
                                        {props.errors.accountholderName}
                                      </p>
                                    )}
                                </div>
                              </div>

                              {/* Bank Name */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3 required">
                                  Bank Name
                                </label>

                                <div className="w-100 col">
                                  <CustomInput type="text" name="bankName" />

                                  {props.touched.bankName &&
                                    props.errors.bankName && (
                                      <p className="text-danger">
                                        {props.errors.bankName}
                                      </p>
                                    )}
                                </div>
                              </div>

                              {/* Account Number */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3 required">
                                  Bank Account Number
                                </label>

                                <div className="w-100 col">
                                  <CustomInput
                                    type="text"
                                    name="accountNumber"
                                  />

                                  {props.touched.accountNumber &&
                                    props.errors.accountNumber && (
                                      <p className="text-danger">
                                        {props.errors.accountNumber}
                                      </p>
                                    )}
                                </div>
                              </div>

                              {/* IFSC */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3 required">
                                  IFSC code
                                </label>

                                <div className="w-100 col">
                                  <CustomInput type="text" name="ifcCode" />

                                  {props.touched.ifcCode &&
                                    props.errors.ifcCode && (
                                      <p className="text-danger">
                                        {props.errors.ifcCode}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="card-footer">
                          <div className="btn-list justify-content-end">
                            <FormSubmitButton buttonText="Create Request" />

                            <SimpleButton
                              buttonText="Cancel"
                              type="secondary"
                            />
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>

          <FooterwithoutLogin />
        </div>
      </div>
    </>
  );
}

export default ReqRefund;
